import React from 'react';
import { useTranslation } from 'react-i18next';

import { FilterAssets } from '~/components/filters/components/filter-assets/FilterAssets';
import { useFilterActions } from '~/hooks/use-filter-actions/useFilterActions';
import { usePublicLists } from '~/react-query-hooks/usePublicLists';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { useWatchlist } from '~/stores/use-watchlist/useWatchlist';

export const AssetFilter = ({ isPending }: { isPending: boolean }) => {
  const { t } = useTranslation(['watchlistManager']);
  const { data } = usePublicLists();

  const assetFilterGroup = useWatchlist(
    state => state.filterGroups.ASSET_FILTERS
  );
  const { addFilterOption, removeFilterOption } = useFilterActions({
    store: useWatchlist,
    group: 'ASSET_FILTERS',
  });

  const activeFilterOption = assetFilterGroup.activeFilterOptions?.[0];
  const defaultFilter = {
    key: 'entity_tag',
    name: t('watchlistManager:quickAddFromIndex'),
    visible: true,
    searchable: false,
    category: 'Universe',
    locked: true,
    config: {
      multiselect: true,
      name: 'Assets',
      options: [],
    },
  };
  const activeFilter = assetFilterGroup.activeFilters?.[0] ?? defaultFilter;

  const filterProps = {
    filter: activeFilter,
    filterOptions: activeFilterOption?.options ?? [],
    publicLists: data ?? [],
    addFilterOption,
    removeFilterOption,
    withWorkingLists: false,
    withScreeners: false,
    withWatchlists: false,
    showListTitle: false,
    multiselect: true,
    dropdownMaxHeight: '420px',
    isPending,
    source: POSTHOG_TRACKING_SOURCES.WATCHLIST_MANAGER_WIDGET,
  };

  return <FilterAssets {...filterProps} />;
};
